

// @flow
import { isEmpty } from 'utils';
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: '/km',
  component: () => import('modules/km/Index.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'KM',
            name: 'PainelKM'
          }
        ]
      },
      name: 'PainelKM',
      component: () => import('modules/km/km.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.km.visualizar')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/history',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'KM',
            name: 'PainelKM'
          },
          {
            text: 'Histórico',
            name: 'History'
          }
        ]
      },
      name: 'History',
      component: () => import('modules/km/history/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.km.historico')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/my-address',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'KM',
            name: 'PainelKM'
          },
          {
            text: 'Meus Endereços',
            name: 'MyAddress'
          }
        ]
      },
      name: 'MyAddress',
      component: () => import('modules/km/MyAddress/MyAddress.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.km.enderecos')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/journey',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'KM',
            name: 'PainelKM'
          },
          {
            text: 'Jornada',
            name: 'Journey'
          }
        ]
      },
      name: 'Journey',
      component: () => import('modules/km/journey/Journey.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.km.jornada')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/journey/edit',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'KM',
            name: 'PainelKM'
          },
          {
            text: 'Jornada',
            name: 'Journey'
          },
          {
            text: 'Criar Rota',
            name: 'JourneyCreate'
          }
        ]
      },
      name: 'JourneyCreate',
      component: () => import('modules/km/journey/CreateAndEditJourney.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.km.jornada') && !isEmpty(to.params)) {
          next();
        } else {
          next('/journey');
        }
      }
    },
    {
      path: '/journey/edit',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'KM',
            name: 'PainelKM'
          },
          {
            text: 'Jornada',
            name: 'Journey'
          },
          {
            text: 'Editar Rota',
            name: 'JourneyEdit'
          }
        ]
      },
      name: 'JourneyEdit',
      component: () => import('modules/km/journey/CreateAndEditJourney.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.km.jornada') && !isEmpty(to.params)) {
          next();
        } else {
          next('/journey');
        }
      }
    },
    {
      path: '/add-journey',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'KM',
            name: 'PainelKM'
          },
          {
            text: 'Jornada',
            name: 'Journey'
          },
          {
            text: 'Adicionar Rota',
            name: 'AddJourney'
          }
        ]
      },
      name: 'AddJourney',
      component: () => import('modules/km/journey/AddJourney.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.km.jornada')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/journey/edit',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'KM',
            name: 'PainelKM'
          },
          {
            text: 'Jornada',
            name: 'Journey'
          },
          {
            text: 'Criar Rota',
            name: 'JourneyCreate'
          }
        ]
      },
      name: 'JourneyCreate',
      component: () => import('modules/km/journey/CreateAndEditJourney.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.km.jornada') && !isEmpty(to.params)) {
          next();
        } else {
          next('/journey');
        }
      }
    },
    {
      path: '/journey/edit',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'KM',
            name: 'PainelKM'
          },
          {
            text: 'Jornada',
            name: 'Journey'
          },
          {
            text: 'Editar Rota',
            name: 'JourneyEdit'
          }
        ]
      },
      name: 'JourneyEdit',
      component: () => import('modules/km/journey/CreateAndEditJourney.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.km.jornada') && !isEmpty(to.params)) {
          next();
        } else {
          next('/journey');
        }
      }
    },
    {
      path: '/add-journey',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'KM',
            name: 'PainelKM'
          },
          {
            text: 'Jornada',
            name: 'Journey'
          },
          {
            text: 'Adicionar Rota',
            name: 'AddJourney'
          }
        ]
      },
      name: 'AddJourney',
      component: () => import('modules/km/journey/AddJourney.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.km.jornada')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/IconListReport',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'KM',
            name: 'PainelKM'
          },
          {
            text: 'Relatórios',
            name: 'IconListReport'
          }
        ]
      },
      name: 'IconListReport',
      component: () => import('modules/km/IconListReport/IconListReport.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.km.relatorios')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/KmReport',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'KM',
            name: 'PainelKM'
          },
          {
            text: 'Relatórios',
            name: 'IconListReport'
          },
          {
            text: 'Relatório de KM',
            name: 'KmReport'
          }
        ]
      },
      name: 'KmReport',
      component: () => import('modules/km/IconListReport/KmReport.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.km.relatorios.relatorio_de_km')) {
          next();
        } else {
          next('/');
        }
      }
    }
  ]
};
